import { GenexSISModel } from "@/models/sis/GenexSISModel";
import GenexHelperMixins from "../../mixins/GenexHelperMixins";
import { normalize } from "@/utils/data";

/**
 * A Custom Year
 * @property {number} id
 * @property {string} name
 * @property {string} start
 * @property {string} end
 */

export default class CustomYear extends GenexSISModel {
  static entity = "years";

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(""),
      start: this.attr(""),
      end: this.attr(""),
    };
  }

  /**
   * Returns all custom years
   * @function
   * @param {Object} pagination
   * @param {number} pagination.page - Which page to retrieve
   * @param {number} pagination.limit - How many entities to retrieve
   * @param {?Object} [query={}] - Query terms for the request
   * @param {Array.<string>} [relationships=[]] - Relationships to bring along
   * @param {Boolean} save
   * @returns {Promise<Response>}
   */

  static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
    return this.api().get(`/years`, {
      ...GenexHelperMixins.methods.DefaultSISHeadersAndBaseUrl(),
      params: {
        ...{
          page: page,
          limit: limit,
          with: relationships,
        },
        ...(query !== {} ? query : {}),
      },
      dataTransformer: ({data: {data}}) => {
        return normalize(data);
      },
    });
  }
}
